/** Objectives — they double as onboarding (the banner tells you what to do next)
 *  and a light progression spine. Predicates live in sim/progress.ts. */
export interface GoalDef {
  id: string;
  label: string;
  hint: string;
  reward: number; // cash
}

export const GOALS: GoalDef[] = [
  { id: 'first-building', label: 'Buy your first building', hint: 'You’re broke — open the City map and pick the cheapest plot.', reward: 0 },
  { id: 'first-cash', label: 'Make your first sales', hint: 'Your dealer sells what the grower makes. Watch the cash climb.', reward: 0 },
  { id: 'hire', label: 'Grow the crew to 3', hint: 'Recruits wander in — accept one when the card pops up.', reward: 150 },
  { id: 'build', label: 'Expand the operation', hint: 'Tap an empty slot in the tower to build a room.', reward: 200 },
  { id: 'lookout', label: 'Set up a Lookout', hint: 'HEAT brings police. Build a Lookout to cut heat and defend raids.', reward: 250 },
  { id: 'survive', label: 'Survive a police raid', hint: 'When the siren hits: lay low, bribe out, or let your crew defend.', reward: 400 },
  { id: 'expand', label: 'Buy a second building', hint: 'Open the City map and buy another building to grow your empire.', reward: 0 },
];

export function goalById(id: string): GoalDef | undefined {
  return GOALS.find((g) => g.id === id);
}
